import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as Enpoints from "../../entities/Endpoints";
import { updateWeightGoal } from "../../api/membershipOverviewApi";
import { fetchMembershipOverview } from "./membershipOverviewSlice";

// Async thunk for updating the weight goal
export const updateWeightGoalThunk = createAsyncThunk(
  Enpoints.UPDATE_CLIENT_WEIGHT_GOAL,
  async ({ payload }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateWeightGoal(payload);

      // Call fetchMembershipOverview from another slice
      dispatch(fetchMembershipOverview(payload?.clientId));
      
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error || "Something went wrong while updating weight goal."
      );
    }
  }
);

const initialState = {
  loading: false,
  success: false,
  error: null,
};

const weightGoalSlice = createSlice({
  name: "weightGoal",
  initialState,
  reducers: {
    resetWeightGoalState: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateWeightGoalThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWeightGoalThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.success = action.payload.message || action.error.message;
      })
      .addCase(updateWeightGoalThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetWeightGoalState } = weightGoalSlice.actions;
export default weightGoalSlice.reducer;
